import React from 'react';

import { SuperCardBox, HeaderSuperCardBox, BodySuperCardBox } from '../SuperCardBox';
import Text from '../Text/Text';
import Button from '../Modules/Button';
import Url from '../../../Helpers/Url';

const BeneficioExclusivoBanner = () => {
    return (
        <SuperCardBox bgState="blue">
            <HeaderSuperCardBox>
                <Text tag="p" size="5xs" font="arial" weight="bold">
                    BENEFICIO EXCLUSIVO
                </Text>
                <Text tag="h5" size="--twoxs" font="arial" weight="bold">
                    Acceso Digital Bonificado
                </Text>
            </HeaderSuperCardBox>

            <BodySuperCardBox>
                <Text tag="p" size="4xs" font="arial" className="--paragraph --mb-16">
                    Por ser parte de CLUB LA NACION tenés Acceso Digital SIN CARGO. Comenzá a disfrutar de este beneficio.
                </Text>
                <Button tag="a" href={Url.ObtenerLinkActivarSuscripcion()} label="ACTIVAR BENEFICIO" />
            </BodySuperCardBox>
        </SuperCardBox>
    );
};

export default BeneficioExclusivoBanner;
